import React from 'react'
import './Mycustombutton.css';
export const Mycustombutton = ({ label, onClick, className = "" ,isActive=false,eventName,typeName}) => {  
  return (
    <button onClick={onClick}   className={`serviceactionBtn ${isActive ? "activebuttonforevetn" : ""}`}>
      {label}
    </button>
  );
};

